import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandAccountsListPage_DeleteBrandAccount($brandAccountId: ID!) {
    deleteBrandAccount(id: $brandAccountId) {
      result
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useDeleteBrandAccountMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Variables['brandAccountId'], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (brandAccountId) =>
      graphQLRequest({ document, variables: { brandAccountId } }),
    ...options,
  })
}
